import styled from 'styled-components';
import Text from 'v3/components/Text';

export const AccordionContainer = styled.div`
  border: 1px solid #E4E6EF;
  border-radius: 6px;
  overflow: hidden;
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: #F9F9F9;
  cursor: ${({ isExpandable }) => (isExpandable ? 'pointer' : 'default')};
  gap: 0.5rem;
  user-select: none;
`;

export const FileIconWrapper = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const FileNameText = styled(Text)`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const NfBadge = styled.span`
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.72rem;
  font-weight: 600;
  flex-shrink: 0;
  white-space: nowrap;
  background: #E8F5E9;
  color: #2e7d32;
`;

export const DateText = styled(Text)`
  flex-shrink: 0;
  white-space: nowrap;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.1rem;
  flex-shrink: 0;
`;

export const ActionButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.3rem;
  border-radius: 4px;
`;

export const DownloadLink = styled.a`
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.3rem;
  border-radius: 4px;
  text-decoration: none;
`;

export const ChevronWrapper = styled.span`
  flex-shrink: 0;
  color: #9E9E9E;
  line-height: 0;
`;

export const AccordionBody = styled.div`
  padding: 0.75rem;
  border-top: 1px solid #E4E6EF;
`;
